export const DEFAULT_LNG = 'en';
export const APPLICATION_LNG_STORAGE_KEY = 'applicationLng';
